import styled from "styled-components";
import colors from "../../config/colors";

export const LabelizeContainer = styled.div`
  margin-bottom: ${(props) => (props.isMeetingRequest ? "20px" : "5px")};
  ${(props) =>
    props.horizontal &&
    `
        display:flex;
        align-items:center;
        margin:0px;
        justify-content:space-between;
          @media (max-width: 768px) {
                  flex-direction: column;
        }
        
    `}
`;
// export const Label=styled.div`
//     font-size:12px;
//     font-weight:bold;
//     margin-bottom:5px;
//     color:${colors.primary};
//     ${props=>props.horizontal && `
//         font-size:14px;
//         margin-left:5px;
//     `}
// `;

export const Label = styled.div`
  color: ${(props) =>
    props.isAvailability
      ? "#4F449B"
      : props.applicationLabel || props.isMeetingRequest
      ? "#302F2F"
      : props.modalStyleLabel
      ? "#44449B"
      : "#757575"};
  font-size: ${(props) => (props.applicationLabel ? "20px" : "16px")};
  font-style: normal;
  font-weight: ${(props) =>
    props.applicationLabel || props.modalStyleLabel ? "700" : "400"};
  line-height: normal;
  text-align: left;
  margin-bottom: ${(props) => (props.applicationLabel ? "0" : "8px")};
  font-family: "Nunito Sans";
  ${(props) =>
    props.styleType &&
    `
    font-size: 12px;
    font-weight:bold;
    margin-bottom:5px;
    color:${colors.primary};
  `}
`;

export const RedText = styled.span`
  color: red;
  font-weight: 500;
`;
